const departments = {
    leader: 'مسئول',
    leaders: 'مسئولان بخش',
    led_departments: 'بخش‌های تحت مدیریت',
    edit_leaders: 'مدیریت مسئولان',
    add_leader: 'افزودن',
    remove_leader: 'حذف',
    no_leaders: 'مسئولی تعیین نشده',
    local: 'مدیریت محلی',
    managed_members: 'اعضای محدوده مدیریت',
    leader_scope_hint: 'عضویت بخش‌های خود و زیربخش‌ها را مدیریت کنید.',
    leader_permission_hint: 'مسئولان عضویت بخش‌های خود و زیربخش‌ها را مدیریت می‌کنند و نقش‌ها یا ساختار سازمان را تغییر نمی‌دهند.',
    primary_synced: 'بخش اصلی توسط Feishu مدیریت می‌شود.',
    status_active: 'فعال',
    status_suspended: 'تعلیق‌شده',
    status_departed: 'خارج‌شده',
    status_pending: 'در انتظار فعال‌سازی',
    search: 'جستجو',
    previous_page: 'صفحه قبلی',
    next_page: 'صفحه بعدی',
    directory_title: 'اعضای سازمان',
    member_name: 'عضو',
    search_members: 'جستجو بر اساس نام یا نام کاربری',
    include_descendants: 'شامل بخش‌های فرعی',
    no_members: 'عضو منطبقی یافت نشد.',
    all_members: 'همه اعضا',
    all_departments: 'همه بخش‌ها',
    edit_member: 'ویرایش بخش‌ها',
    add_child: 'افزودن بخش فرعی',
    expand_department: 'باز کردن {{name}}',
    collapse_department: 'بستن {{name}}',
    title: 'بخش‌ها',
    description: 'بخش‌ها و عضویت اعضا را در این سازمان مدیریت کنید.',
    create: 'ایجاد بخش',
    edit: 'ویرایش بخش',
    name: 'نام بخش',
    parent: 'بخش بالادست',
    root: 'بدون بخش بالادست',
    id: 'شناسه بخش',
    members: 'بخش‌های اعضا',
    member_id: 'شناسه کاربری عضو',
    primary: 'بخش اصلی',
    none: 'تنظیم نشده',
    assignments: 'عضویت بخش‌ها',
    no_assignments: 'هنوز عضویتی در بخش‌ها وجود ندارد.',
    assignment_hint: 'بخش‌های محلی و در صورت نیاز یک بخش اصلی تعیین کنید. عضویت‌های فهرست فقط خواندنی هستند.',
    empty: 'هنوز بخشی وجود ندارد.',
    readonly: 'می‌توانید بخش‌ها و عضویت خود را ببینید. برای تغییر با مدیر سازمان تماس بگیرید.',
    load_error: 'بارگیری داده‌ها ناموفق بود. دوباره تلاش کنید.',
    mutation_error: 'ذخیره نشد. مجوزها، عضویت و سلسله‌مراتب بخش‌ها را بررسی کنید.',
    loading: 'در حال بارگیری…',
    synced: 'مدیریت‌شده توسط فهرست',
    choose: 'جستجوی بخش‌ها',
    organizations_title: 'سازمان‌ها و بخش‌ها',
    organizations_description: 'برای مشاهده یا مدیریت بخش‌ها، سازمانی انتخاب کنید.',
    no_organizations: 'عضو هیچ سازمانی نیستید. با مدیر سازمان تماس بگیرید.',
    organization: 'سازمان فعلی',
    choose_organization: 'انتخاب سازمان',
    delete_title: 'حذف بخش',
    delete_description: '«{{name}}» حذف شود؟ ابتدا اعضا و زیربخش‌ها را منتقل کنید.',
};
export default Object.freeze(departments);
